import React, { useEffect, useState } from "react";
import TableCompo from "../Table/TableCompo";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Box, Grid, TextField, Button, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicDialog from "../../Modals/CommanDialog";
import { changeStatus } from "../../../redux/slices/manageMetals";
import { getAppConfig } from "../../../redux/Configuration/configurationSlice";
import { updateBullionTaxRequest } from "../../../redux/Bullion/BullionSlice";
import useCsvConverter from "../../../hooks/convertToCSV";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import { fetchMetals } from "../../../redux/slices/metalRateSlice";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";
import { toast } from "react-toastify";

const Changemetalstatetable = () => {
  const metals = useSelector((state) => state.metals?.metals || []);
  const configData = useSelector((state) => state?.appConfig?.configData || {});
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedMetal, setSelectedMetal] = useState({});
  const [tax, setTax] = useState();
  const [cgst, setCgst] = useState();
  const [sgst, setSgst] = useState();
  const [igst, setIgst] = useState();
  const [cess, setCess] = useState();
  const [margin, setMargin] = useState("Percentage");
  const [marginValue, setMarginValue] = useState("");
  const [rateType, setRateType] = useState("Buy");
  const [selectedMetalName, setSelectedMetalName] = useState(null);
  const taxType = configData?.taxtype || "GST";
  const states = useSelector((state) => state.metalRate?.states || []);
  const [selectedStates, setSelectedStates] = useState([]);
  const [stateDetails, setStateDetails] = useState([]);
  console.log("taxType", taxType);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem("userPermissions");
    if (stored) {
      try {
        setPermissions(JSON.parse(stored));
      } catch (e) {
        console.error("permission parse error", e);
      }
    }
  }, []);
  const [liveRates, setLiveRates] = useState(false);
  useEffect(() => {
    if (Object.keys(configData).length) {
      setLiveRates(configData?.featureToggle?.Live_Rates === true);
    }
  }, [configData]);
  console.log("liveRates",liveRates);
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [filteredStates, setFilteredStates] = useState([]);
  const [initialStateDetails, setInitialStateDetails] = useState([]);
  const [activeState, setActiveState] = useState(null);
  const [activeRateType, setActiveRateType] = useState(null);
  const [activeCountryId, setActiveCountryId] = useState(null);
  const [selectedJewellerId, setSelectedJewellerId] = useState(() => {
    return sessionStorage.getItem(auth.selectedJeweller) || "";
  });
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const jewellerID = storedUser?.jeweller;
  const finalJewellerId =
    selectedJewellerId && selectedJewellerId.trim() !== ""
      ? selectedJewellerId
      : jewellerID;
  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller: finalJewellerId }));
  }, [dispatch]);

  const canCreateMetal = canShowPermission(permissions, "editMetal", "create");
  const canEdit = canShowPermission(permissions, "editMetal", "edit");
  const canDelete = canShowPermission(permissions, "editMetal", "delete");
  // useEffect(() => {
  //   dispatch(getAppConfig());
  // }, []);

  const handleOpen = (row) => {
    setSelectedMetal(row);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleSubmit = () => {
    dispatch(
      changeStatus({
        metalName: selectedMetal.metalName,
        purity: selectedMetal.purity,
        status: !selectedMetal.status,
      }),
    );
    handleClose();
  };

  const [editOpen, setEditOpen] = useState(false);
  const [selectedMetalForEdit, setSelectedMetalForEdit] = useState(null);
  console.log("selectedMetalForEdit", selectedMetalForEdit);
  const handleEditOpen = (metal) => {
    setSelectedMetalForEdit(metal);
    setSelectedMetalName(metal || "");
    setTax(metal.tax || "");
    setCgst(metal.cgst || "");
    setSgst(metal.sgst || "");
    setIgst(metal.tax || "");
    setCess(metal.cess || "");
    let allStates = [];

    metal?.marginData?.forEach((m) => {
      if (m.stateDetails?.length) {
        const countryId = m.country?._id || m.country || null;
        const countryCode =
          m.country?.countryCode ||
          activeCountries.find((c) => c._id === countryId)?.countryCode ||
          "";

        m.stateDetails.forEach((st) => {
          allStates.push({
            ...st,
            country: m.country,
            countryCode,
          });
        });
      }
    });

    setInitialStateDetails(allStates);
    setStateDetails([]);

    if (allStates.length > 0) {
    const first = allStates[0];

    setActiveState(first.state);
    setActiveRateType(first.rateType);
    setActiveCountryId(first.country?._id || first.country || null);
    setMargin(first.marginType || "Percentage");
    setMarginValue(first.margin ?? "");
    setSelectedStates([first.state]);
    setRateType(first.rateType);

    if (first.country?._id) {
      const matched = activeCountries.find((c) => c._id === first.country._id);
      if (matched) {
        setSelectedCountry(matched.countryCode);
        setFilteredStates(matched.states || []);
      }
    }
  }

    setEditOpen(true);
  };

  const handleEditClose = () => {
    setSelectedMetalForEdit(null);
    setEditOpen(false);
    setTax("");
    setCgst("");
    setSgst("");
    setIgst("");
    setCess("");
    setMargin("Percentage");
    setMarginValue("");
    setSelectedStates([]);
    setStateDetails([]);
    setInitialStateDetails([]);
    setSelectedCountry("");
    setFilteredStates([]);
    setActiveState(null);
    setActiveCountryId(null);
    setSelectedMetalName(null);
  };

  const handleUpdateMetal = () => {
    if (!selectedMetalForEdit) return;

    const payload = {
      taxType: taxType,
      tax: Number(tax) || 0,
      cgst: Number(cgst) || 0,
      sgst: Number(sgst) || 0,
      igst: Number(igst) || 0,
      cess: Number(cess) || 0,
    };

    // if (liveRates) {
    const matchedCountry = activeCountries.find(
      (c) => c.countryCode === selectedCountry,
    );
    payload.stateDetails = stateDetails;
    payload.country = matchedCountry?._id;
    // }

    dispatch(
      updateBullionTaxRequest({
        bullionId: selectedMetalForEdit._id,
        data: payload,
      }),
    );

    handleEditClose();
  };

  useEffect(() => {
    dispatch(fetchMetals());
  }, [dispatch]);
  // useEffect(() => {
  //   if (!liveRates) {
  //     setMargin("");
  //     setMarginValue("");
  //     setSelectedStates([]);
  //   }
  // }, [liveRates]);
  const handleAddState = () => {
    if (!selectedStates || selectedStates.length === 0) return;

    let newStates = [];

    if (selectedStates.includes("All")) {
      newStates = [
        {
          state: "All",
          margin: Number(marginValue) || 0,
          marginType: margin,
          rateType: rateType,
        },
      ];
    } else {
      newStates = selectedStates.map((st) => ({
        state: st,
        margin: Number(marginValue) || 0,
        marginType: margin,
        rateType: rateType,
      }));
    }

    setStateDetails((prev) => {
      const merged = [...prev];

      newStates.forEach((ns) => {
        const exists = merged.find(
          (m) => m.state === ns.state && m.rateType === ns.rateType,
        );
        if (!exists) {
          merged.push(ns);
        }
      });

      return merged;
    });

    setSelectedStates([]);
  };
  const handleRemoveState = (stateName, rateType) => {
    setStateDetails((prev) =>
      prev.filter((s) => !(s.state === stateName && s.rateType === rateType)),
    );
  };
  const handlePrefillState = (item) => {
    setActiveState(item.state);
    setActiveRateType(item.rateType);
    setActiveCountryId(item.country?._id || item.country || null);
    setMargin(item.marginType);
    setMarginValue(item.margin);
    setSelectedStates([item.state]);
    setRateType(item.rateType);

    if (item.country?._id) {
      const matched = activeCountries.find((c) => c._id === item.country._id);

      if (matched) {
        setSelectedCountry(matched.countryCode);
        setFilteredStates(matched.states || []);
      }
    }
  };

  useEffect(() => {
    if (!liveRates) {
      setMargin("Percentage");
      setMarginValue("0");
    }
  }, [liveRates]);

  const columns = [
    { field: "metalName", headerName: "Metal Name" },
    {
      field: "purity",
      headerName: "Purity",
      render: (value, row) => {
        return `${row.karat}k-${row.purity}`;
      },
    },

    {
      field: "status",
      headerName: "Status",
      render: (value, row) => {
        const isEnabled = row.status === true;
        if (!canEdit) {
          return (
            <Box sx={{ textAlign: "center", width: "100%" }}>
              <span
                style={{
                  fontWeight: 600,
                  color: isEnabled ? "#43a047" : "#e53935",
                }}
              >
                {isEnabled ? "Enable" : "Disable"}
              </span>
            </Box>
          );
        }

        return (
          <button
            style={{
              backgroundColor: isEnabled ? "#43a047" : "#e53935",
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleOpen(row)}
          >
            {isEnabled ? "Enable" : "Disable"}
          </button>
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      render: (_, row) => {
        if (!canEdit) return null;
        return (
          <CiEdit
            size={20}
            style={{ cursor: "pointer", color: "#1976d2" }}
            onClick={() => handleEditOpen(row)}
          />
        );
      },
    },
  ];

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/bullion/bullionCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "metal.csv");
        },
      }),
    );
  };

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const handleTableChange = (type, payload) => {
    if (type === "changePage") {
      setPage(payload.page);
    }

    if (type === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }
  };

  const paginatedMetals = Array.isArray(metals)
    ? metals.slice(page * limit, page * limit + limit)
    : [];

  const availableStates = filteredStates.filter(
    (st) => !stateDetails.some((sd) => sd.state === st),
  );

  return (
    <>
      {" "}
      <DynamicDialog
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="Change Metal Status"
        message="Are you sure you want to change the status of the metal?"
        cancelText="Cancel"
        submitText="Submit"
      />
      <DynamicDialog
        open={editOpen}
        onClose={handleEditClose}
        onSubmit={handleUpdateMetal}
        title={`Edit Metal Tax - ${selectedMetalName?.metalName || ""} (${
          selectedMetalName?.karat || ""
        }k- ${selectedMetalName?.purity || ""})`}
        message={
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 2,
                  mt: 1,
                }}
              >
                <Box sx={{ fontWeight: 600, mb: 1 }}>Tax Details</Box>
                <Grid container spacing={2}>
                  {taxType === "VAT" && (
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Tax (%)"
                          value={tax}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                              setTax(value);
                            }
                          }}
                          fullWidth
                          sx={{ marginTop: "10px" }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Cess (%)"
                          value={cess}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                              setCess(value);
                            }
                          }}
                          fullWidth
                          sx={{ marginTop: "10px" }}
                        />
                      </Grid>
                    </>
                  )}
                  {taxType === "GST" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="CGST (%)"
                          value={cgst}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                              setCgst(value);
                            }
                          }}
                          fullWidth
                          sx={{ marginTop: "10px" }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="SGST (%)"
                          value={sgst}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                              setSgst(value);
                            }
                          }}
                          fullWidth
                          sx={{ marginTop: "10px" }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="IGST (%)"
                          value={igst}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                              setIgst(value);
                            }
                          }}
                          fullWidth
                          sx={{ marginTop: "10px" }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            </Grid>

            {/* {liveRates && ( */}
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 2,
                }}
              >
                
                <Box sx={{ fontWeight: 600, mb: 1 }}> 
                  {!liveRates ?
                    "State Details" : "Margin Details (Note: Margin will be applied on live rates) "
                  }
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        mb: 2,
                        width: "100%",
                        minHeight: "32px",
                        alignItems: "center",
                      }}
                    >
                      {initialStateDetails.map((item, index) => (
                        <Button
                          key={index}
                          variant="outlined"
                          size="small"
                          sx={{
                            textTransform: "none",
                            borderRadius: "20px",
                            px: 2,
                            whiteSpace: "nowrap",
                            backgroundColor:
                              activeState === item.state &&
                              activeRateType === item.rateType &&
                              (activeCountryId || null) ===
                                (item.country?._id || item.country || null)
                                ? "#1976d2"
                                : "transparent",
                            color:
                              activeState === item.state &&
                              activeRateType === item.rateType &&
                              (activeCountryId || null) ===
                                (item.country?._id || item.country || null)
                                ? "#fff"
                                : "#000",
                            border: "1px solid #1976d2",
                          }}
                          onClick={() => handlePrefillState(item)}
                        >
                          {item.countryCode ? `${item.countryCode} ` : ""}
                          {item.state} ({item.rateType})
                        </Button>
                      ))}
                    </Box>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        label="Country"
                        value={selectedCountry}
                        onChange={(e) => {
                          const selectedCode = e.target.value;
                          const matched = activeCountries.find(
                            (c) => c.countryCode === selectedCode,
                          );

                          if (!matched) return;

                          setSelectedCountry(selectedCode);
                          setFilteredStates(matched.states || []);
                          setSelectedStates([]);
                        }}
                        fullWidth
                        sx={{
                          marginTop: "10px",
                          minWidth: { xs: "170px", sm: "225px" },
                        }}
                      >
                        {activeCountries.map((country) => (
                          <MenuItem
                            key={country._id}
                            value={country.countryCode}
                          >
                            {country.countryName} ({country.countryCode})
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        label="State"
                        value={selectedStates}
                        onChange={(e) => setSelectedStates(e.target.value)}
                        fullWidth
                        SelectProps={{ multiple: true }}
                        sx={{
                          marginTop: "10px",
                          minWidth: { xs: "170px", sm: "225px" },
                        }}
                      >
                        <MenuItem value="All">All</MenuItem>

                        {availableStates.map((state) => (
                          <MenuItem key={state} value={state}>
                            {state}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        label="Rate Type"
                        value={rateType}
                        onChange={(e) => setRateType(e.target.value)}
                        fullWidth
                        sx={{
                          marginTop: "10px",
                          minWidth: { xs: "170px", sm: "225px" },
                        }}
                      >
                        <MenuItem value="Buy">Buy</MenuItem>
                        <MenuItem value="Sell">Sell</MenuItem>
                      </TextField>
                    </Grid>
                    {liveRates &&(
                       <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        label="Margin Type"
                        value={margin}
                        onChange={(e) => setMargin(e.target.value)}
                        fullWidth
                        sx={{
                          marginTop: "10px",
                          minWidth: { xs: "170px", sm: "225px" },
                        }}
                      >
                        <MenuItem value="Fixed">Fixed</MenuItem>
                        <MenuItem value="Percentage">Percentage</MenuItem>
                      </TextField>
                    </Grid>
                    )}
                    
                    {liveRates && (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Margin Value"
                        value={marginValue}
                        onChange={(e) => {
                          let value = e.target.value;

                            if (!/^-?(?:\d+\.?\d*|\.\d*)?$/.test(value)) return;

                          let num = Number(value);
                          const absValue = Math.abs(num);

                          if (margin === "Percentage" && absValue > 25) {
                            toast.error("Max allowed is ±25%");
                            return;
                          }

                          if (margin === "Fixed" && absValue > 5000) {
                            toast.error("Max allowed is ±5000");
                            return;
                          }

                          setMarginValue(value);
                        }}
                        fullWidth
                        sx={{ marginTop: "10px" }}
                      />
                    </Grid>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      onClick={handleAddState}
                      sx={{ mt: 1 }}
                    >
                      Add
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {stateDetails.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: selectedStates.includes(item.state)
                              ? "#90caf9"
                              : "#e3f2fd",
                            padding: "5px 10px",
                            borderRadius: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handlePrefillState(item)}
                        >
                          {item.state} ({item.marginType}-{item.margin}) [
                          {item.rateType}]
                          <span
                            style={{
                              marginLeft: "8px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveState(item.state, item.rateType);
                            }}
                          >
                            ✖
                          </span>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            {/* )} */}
          </Grid>
        }
        cancelText="Cancel"
        submitText="Update"
      />
      <TableCompo
        columns={columns}
        data={paginatedMetals}
        page={page}
        limit={limit}
        totalCount={metals?.length || 0}
        onTableChange={handleTableChange}
        extraButtons={
          <Button size="sm" variant="outlined" onClick={handleDownloadCsv}>
            Download CSV
          </Button>
        }
      />{" "}
    </>
  );
};

export default Changemetalstatetable;
